import { ELSStepperItem } from '@els/els-component-shared-ts-react';
import { AssignmentType } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { RecContentItemTypeDto } from '../../apis/rec-gateway/rec-gateway.dtos';

export const isUseAssignmentIdForPerformanceIndicator = 'PERFORMANCE_BY_ASSIGNMENT_ID';

export const SyllabusAssignmentApiTypes = [
  AssignmentType.SHADOW_HEALTH
];

export const IndependentGoalsTypes = [
  AssignmentType.INTERACTIVE_REVIEW,
  AssignmentType.SLS_PRE_SIMULATION_QUIZ,
  AssignmentType.SLS_POST_SIMULATION_QUIZ,
  AssignmentType.SLS_JOURNALING_EXERCISE,
  AssignmentType.SLS_VERBAL_REPORT_TEMPLATE,
  AssignmentType.SLS_OBSERVER_EVALUATION_RUBRIC,
  AssignmentType.SLS_PERFORMANCE_CHECKLIST,
  AssignmentType.ADAPTIVE_LESSON,
  AssignmentType.LESSONS,
  AssignmentType.SKILL,
  AssignmentType.SIMULATIONS,
  AssignmentType.SHADOW_HEALTH,
];

export const DEFAULT_GRADEPOINTS_MAP: Partial<Record<AssignmentType, number>> = {
  [AssignmentType.SLS_PRE_SIMULATION_QUIZ]: 100,
  [AssignmentType.SLS_POST_SIMULATION_QUIZ]: 100,
  [AssignmentType.SCMO_NG]: 100,
  [AssignmentType.SLS_PATIENT_REPORT]: 100,
  [AssignmentType.ADAPTIVE_LESSON]: 100,
  [AssignmentType.SLS_READING_ASSIGNMENT]: 100,
  [AssignmentType.LESSONS]: 100,
  [AssignmentType.SKILL]: 100,
  [AssignmentType.SIMULATIONS]: 100,
  [AssignmentType.SHADOW_HEALTH]: 100,
  [AssignmentType.HESI_ASSESS]: 100,
  [AssignmentType.SLS_JOURNALING_EXERCISE]: 100,
  [AssignmentType.SLS_VERBAL_REPORT_TEMPLATE]: 100,
  [AssignmentType.SLS_OBSERVER_EVALUATION_RUBRIC]: 100,
  [AssignmentType.SLS_PERFORMANCE_CHECKLIST]: 100,
};

export const SIMULATION_EXERCISE_ASSIGNMENT_TITLE = 'Simulation Exercise Assignment';

export const EDITOR_PAGE_TITLE_MAP: Partial<Record<AssignmentType, string>> = {
  [AssignmentType.SLS_PRE_SIMULATION_QUIZ]: 'Pre-Simulation Quiz Assignment',
  [AssignmentType.SLS_POST_SIMULATION_QUIZ]: 'Post-Simulation Quiz Assignment',
  [AssignmentType.SCMO_NG]: 'SimChart for the Medical Office Assignment',
  [AssignmentType.SLS_PATIENT_REPORT]: 'Patient Report Assignment',
  [AssignmentType.SLS_READING_ASSIGNMENT]: 'Reading Assignment',
  [AssignmentType.LESSONS]: 'Sherpath Lesson Assignment',
  [AssignmentType.SKILL]: 'Sherpath Skill Assignment',
  [AssignmentType.SIMULATIONS]: 'Sherpath Simulation Assignment',
  [AssignmentType.SHADOW_HEALTH]: 'Shadow Health Assignment',
  [AssignmentType.HESI_ASSESS]: 'HESI Assess Assignment',
  [AssignmentType.SLS_JOURNALING_EXERCISE]: SIMULATION_EXERCISE_ASSIGNMENT_TITLE,
  [AssignmentType.SLS_VERBAL_REPORT_TEMPLATE]: 'Verbal Report Template Assignment',
  [AssignmentType.SLS_OBSERVER_EVALUATION_RUBRIC]: 'Observer Evaluation Rubric Assignment',
  [AssignmentType.SLS_PERFORMANCE_CHECKLIST]: 'Performance Checklist Assignment',
};

export enum CommonSteps {
  STEP1 = 'STEP1',
}

export const CommonAssignmentDefaultSteps: ELSStepperItem[] = [{
  heading: 'Assignment',
  id: CommonSteps.STEP1,
  isActive: false,
  isClickable: false,
  isComplete: false,
  isReady: false,
  showActionButtons: true,
  subtitle: 'Assignment',
  title: 'Step 1',
}];

export const REC_CONTENT_TYPE_TO_ASSIGNMENT_TYPE_MAP: Partial<Record<RecContentItemTypeDto, AssignmentType>> = {
  [RecContentItemTypeDto.PRE_SIMULATION_QUIZ]: AssignmentType.SLS_PRE_SIMULATION_QUIZ,
  [RecContentItemTypeDto.POST_SIMULATION_QUIZ]: AssignmentType.SLS_POST_SIMULATION_QUIZ,
  // TODO: Need to verify assignment type
  [RecContentItemTypeDto.PATIENT_REPORT]: AssignmentType.SLS_PATIENT_REPORT,
  [RecContentItemTypeDto.SCMO_NG]: AssignmentType.SCMO_NG,
  [RecContentItemTypeDto.LAB_SIMULATION_IMPLEMENTATION_MODULE]: AssignmentType.SLS_SCENARIO,
  [RecContentItemTypeDto.ADAPTIVE_LESSON]: AssignmentType.ADAPTIVE_LESSON,
  [RecContentItemTypeDto.READING_ASSIGNMENT]: AssignmentType.SLS_READING_ASSIGNMENT,
  [RecContentItemTypeDto.SHERPATH_LESSON]: AssignmentType.LESSONS,
  [RecContentItemTypeDto.SHERPATH_SKILL]: AssignmentType.SKILL,
  [RecContentItemTypeDto.SHERPATH_SIMULATION]: AssignmentType.SIMULATIONS,
  [RecContentItemTypeDto.SHADOW_HEALTH]: AssignmentType.SHADOW_HEALTH,
  [RecContentItemTypeDto.HESI_ASSESS]: AssignmentType.HESI_ASSESS,
  [RecContentItemTypeDto.JOURNAL_EXERCISE]: AssignmentType.SLS_JOURNALING_EXERCISE,
  [RecContentItemTypeDto.PRE_SIMULATION_EXERCISE]: AssignmentType.SLS_JOURNALING_EXERCISE,
  [RecContentItemTypeDto.POST_SIMULATION_EXERCISE]: AssignmentType.SLS_JOURNALING_EXERCISE,
  [RecContentItemTypeDto.SBAR_EXERCISE]: AssignmentType.SLS_JOURNALING_EXERCISE,
  [RecContentItemTypeDto.VERBAL_REPORT_TEMPLATE]: AssignmentType.SLS_VERBAL_REPORT_TEMPLATE,
  [RecContentItemTypeDto.OBSERVER_EVALUATION_RUBRIC]: AssignmentType.SLS_OBSERVER_EVALUATION_RUBRIC,
  [RecContentItemTypeDto.PERFORMANCE_CHECKLIST]: AssignmentType.SLS_PERFORMANCE_CHECKLIST,
};

export const ASSIGNMENT_TYPE_TO_REC_CONTENT_TYPE_MAP: Partial<Record<AssignmentType, RecContentItemTypeDto>> = {
  [AssignmentType.SLS_PRE_SIMULATION_QUIZ]: RecContentItemTypeDto.PRE_SIMULATION_QUIZ,
  [AssignmentType.SLS_POST_SIMULATION_QUIZ]: RecContentItemTypeDto.POST_SIMULATION_QUIZ,
  // TODO: Need to verify assignment type
  [AssignmentType.SLS_PATIENT_REPORT]: RecContentItemTypeDto.PATIENT_REPORT,
  [AssignmentType.SCMO_NG]: RecContentItemTypeDto.SCMO_NG,
  [AssignmentType.SLS_READING_ASSIGNMENT]: RecContentItemTypeDto.READING_ASSIGNMENT,
  [AssignmentType.LESSONS]: RecContentItemTypeDto.SHERPATH_LESSON,
  [AssignmentType.SKILL]: RecContentItemTypeDto.SHERPATH_SKILL,
  [AssignmentType.SIMULATIONS]: RecContentItemTypeDto.SHERPATH_SIMULATION,
  [AssignmentType.SHADOW_HEALTH]: RecContentItemTypeDto.SHADOW_HEALTH,
  [AssignmentType.SLS_JOURNALING_EXERCISE]: RecContentItemTypeDto.JOURNAL_EXERCISE,
  [AssignmentType.SLS_VERBAL_REPORT_TEMPLATE]: RecContentItemTypeDto.VERBAL_REPORT_TEMPLATE,
  [AssignmentType.SLS_OBSERVER_EVALUATION_RUBRIC]: RecContentItemTypeDto.OBSERVER_EVALUATION_RUBRIC,
  [AssignmentType.SLS_PERFORMANCE_CHECKLIST]: RecContentItemTypeDto.PERFORMANCE_CHECKLIST,
};

export const NoAssignmentGoalsTypes = [
  AssignmentType.ADAPTIVE_LESSON
];

export const NoDueDateTypes: AssignmentType[] = [
  AssignmentType.SLS_PATIENT_REPORT,
  AssignmentType.SLS_READING_ASSIGNMENT,
  AssignmentType.HESI_ASSESS,
  AssignmentType.SLS_VERBAL_REPORT_TEMPLATE,
  AssignmentType.SLS_OBSERVER_EVALUATION_RUBRIC,
  AssignmentType.SLS_PERFORMANCE_CHECKLIST,
];

export const SIMULATION_EXERCISE_TYPES: AssignmentType[] = [
  AssignmentType.SLS_JOURNALING_EXERCISE,
];

export const SIMULATION_EXERCISE_REC_TYPES: RecContentItemTypeDto[] = [
  RecContentItemTypeDto.PRE_SIMULATION_EXERCISE,
  RecContentItemTypeDto.POST_SIMULATION_EXERCISE,
  RecContentItemTypeDto.JOURNAL_EXERCISE,
  RecContentItemTypeDto.SBAR_EXERCISE,
];
